<template>
  <div class="flex w-full h-full justify-start flex-col hover:cursor-pointer">
    <div class="flex justify-center lg:gap-3 h-[calc(50%-30px)]">
      <AtomAnimationsRecommendationEqualiser v-if="audioIsPlaying" />
    </div>
    <div class="flex justify-center">
      <AtomIconAppPlayRecommendation v-if="!audioIsPlaying" class="w-[40px] lg:w-[60px] self-center bg-[length: 20%]" />
      <AtomIconAppPauseRecommendation v-else class="w-[40px] lg:w-[60px] self-center bg-[length: 20%]" />
    </div>

    <audio v-if="audio" :id="audio.id">
      <source :src="audio.src" :type="audio.mimeType" />
    </audio>
  </div>
</template>

<script setup lang="ts">
defineProps({
  audio: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  audioIsPlaying: { type: Boolean, required: false, default: undefined },
  togglePlayerState: { type: Function, required: false, default: undefined },
})
</script>

<style lang="scss" scoped></style>
